import { gql } from '@nerdwallet/apollo';

export const MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE =
  'MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE';

const tuAuthenticationQuestionFieldMap = {
  id: 'id',
  sequence: 'sequence',
  text: 'text',
  type: 'type',
  answers: 'answers',
  __typename: undefined,
};

export const TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP = {
  questions: ['questions', tuAuthenticationQuestionFieldMap],
  status: 'status',
  authenticatedAt: 'authenticated_at',
  activatedAt: 'activated_at',
  deactivatedAt: 'deactivated_at',
  reactivatedAt: 'reactivated_at',
  blockedAt: 'blocked_at',
  hasThinFile: 'has_thin_file',
  thinFileReason: 'thin_file_reason',
  isDeceased: 'is_deceased',
  notEnoughData: 'not_enough_data',
  numPullsInPast24Hours: 'num_pulls_in_past_24_hours',
  tuId: 'tu_id',
  previousStatus: 'previous_status',
  message: 'message',
  description: 'description',
  __typename: undefined,
};

const creditProfileAuthStatusProfileFragment = gql`
  fragment CreditProfileAuthStatusProfileFragment on CreditProfileAuthStatusProfile {
    status
    authenticatedAt
    activatedAt
    deactivatedAt
    reactivatedAt
    blockedAt
    questions {
      id
      type
      text
      sequence
      answers {
        id
        text
        sequence
      }
    }
    inOtpFlow
    hasThinFile
    thinFileReason
    isDeceased
    notEnoughData
    numPullsInPast24Hours
    tuId
    previousStatus
    message
    description
  }
`;

export const DEACTIVATE_CREDIT_PROFILE_MUTATION = gql`
  mutation DeactivateCreditProfile {
    deactivateCreditProfile {
      ...CreditProfileAuthStatusProfileFragment
    }
  }
  ${creditProfileAuthStatusProfileFragment}
`;
